import { all } from "redux-saga/effects";

import getSalaryDetailSaga from "./getSalaryDetail";
import verifyIncomeOtpSaga from "./verifyIncomeOtp";
import getListNotifyIncomeSaga from "./getListNotifyIncome";
import getDetailNotifyIncomeSaga from "./getDetailNotifyIncome";

export default function* salarySaga() {
  yield all([
    getSalaryDetailSaga(),
    verifyIncomeOtpSaga(),
    getListNotifyIncomeSaga(),
    getDetailNotifyIncomeSaga(),
  ]);
}
